module.exports = {"selectpicker":{"none_selected_text":"Nothing selected"}};